import React, { Component } from 'react'
import Title from 'antd/lib/typography/Title'
import { Link } from 'react-router-dom';
import {Avatar} from 'antd';

export const BasicCardCenter=(props)=>{
    return <div className='default-card' style={{
        padding: 8,
        margin:0,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center'
      }} >
          {props.icon}
          {props.title}
          {props.subtitle}
        </div>
}



class BasicCard extends Component {
    render() {
        return (
            <div className='default-card' style={{
                padding:8,
                margin:0,
                display:'flex',
                flexDirection:'column',
                height:'100%',
                justifyContent:'space-between'
              }} >
                <div style={{
                  display:'flex',
                  flexDirection:'row',
                  justifyContent:'space-between',
                }}>
                  <div style={{
                    display:'flex',
                    flexDirection:'column'
                  }}>
                    <Title level={4} style={{margin:0}} type='secondary'>{this.props.title}</Title>
                    <Title level={2} style={{margin:0}} >{this.props.subtitle}</Title>
                  </div>
                  <div>
                      {this.props.rightIcon}
                  </div>
    
                </div>
                {this.props.link&&
                <div style={{marginTop:12}}>
                  <Link to={this.props.link||"#"}>View All</Link>
                </div>
                }
              </div>
        )
    }
}

export default BasicCard
